/* eslint-disabled */

export default class PropertyChoiceExtend {


  constructor (object?: any) {
  }

}
